import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import Styles from './GridContainer.styles';

const GridContainer = ({ children, fluid }) => (
  <div
    className={classNames(
      { [Styles.container]: !fluid },
      { [Styles['fluid-container']]: fluid },
    )}
  >
    {children}
  </div>
);

GridContainer.propTypes = {
  children: propTypes.node.isRequired,
  fluid: propTypes.bool,
};

GridContainer.defaultProps = {
  fluid: false,
};

export default GridContainer;
export {
  GridContainer,
};
